import React, { useState , useContext } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import {
  Home, Users, Wrench, LayoutGrid, UserCog, CalendarCheck,
  FileText, HelpCircle, BarChart2, DollarSign,
  HeadphonesIcon, Settings, LogOut, Menu, AlertTriangle,
  X, ChevronDown, ChevronRight, Crown, CheckCircle,  ShieldCheck
} from 'lucide-react';

import { useEffect } from "react";
import AppContext from '../../../../context/AppContext';
import '../../../../assets/css/screens/admin/dashboard/adminsidebar/AdminSidebar.css';

// ── Grouped Menu ──
const MENU_GROUPS = [
  {
    id:    'overview',
    label: null, // no section heading for top items
    items: [
      { id: 'home',   icon: Home,     label: 'Dashboard',    path: '/admin-home'    },
      // { id: 'report', icon: BarChart2, label: 'Reports', path: '/view-report'  },
      { id: 'earn',   icon: DollarSign,label: 'Earnings',path: '/admin-earnings'},
    ],
  },
  // {
  //   id:    'user-management',
  //   label: 'User Management',
  //   icon:  Users,
  //   children: [
  //     { id: 'prov', icon: Wrench,        label: 'Providers',          path: '/admin-providers'          },
      // { id: 'sub',  icon: UserCog,       label: 'Sub Admins',         path: '/admin-subadmins'          },
      // { id: 'rep',  icon: AlertTriangle, label: 'Reported Customers', path: '/admin-reported-customers' },
  //   ],
  // },
{
  id: 'system',
  label: 'System',
  icon: Settings,
  children: [
    { id: 'cats', icon: LayoutGrid, label: 'Categories', path: '/admin-categories' },
    { id: 'bid-jobs', icon: LayoutGrid, label: 'Post Jobs', path: '/system-jobs' },

    // 👇 NEW KYC PAGE
    { id: 'kyc', icon: ShieldCheck, label: 'KYC Verification', path: '/admin-kyc' },

    { id: 'tickets', icon: HeadphonesIcon, label: 'Support Tickets', path: '/support-tickets' },
    { id: 'sub', icon: Crown, label: 'Subscriptions', path: '/admin-subscriptions' },
  ],
},
  {
    id:    'content',
    label: 'Content',
    icon:  FileText,
    children: [
      { id: 'blogs', icon: FileText,  label: 'Blogs', path: '/admin-blogs' },
      { id: 'faq',   icon: HelpCircle,label: 'FAQs',  path: '/admin-faqs'  },
    ],
  },
  {
    id:    'config',
    label: null,
    items: [
      { id: 'settings', icon: Settings, label: 'Settings', path: '/admin-settings' },
    ],
  },
];

// ── Single NavLink item ──
const SidebarLink = ({ item, onClick }) => {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.path}
      className={({ isActive }) => 'asb__link' + (isActive ? ' asb__link--active' : '')}
      onClick={onClick}
    >
      <Icon size={19} className="asb__link-icon" />
      <span className="asb__link-label">{item.label}</span>
      <span className="asb__link-arrow">›</span>
    </NavLink>
  );
};

// ── Collapsible group ──
const SidebarGroup = ({ group, onLinkClick }) => {
  const location = useLocation();
  const isAnyChildActive = group.children?.some(c => location.pathname === c.path);
  const [open, setOpen] = useState(isAnyChildActive);
  const Icon = group.icon;

  return (
    <div className="asb__group">
      <button
        className={`asb__group-btn${open ? ' asb__group-btn--open' : ''}${isAnyChildActive ? ' asb__group-btn--has-active' : ''}`}
        onClick={() => setOpen(o => !o)}
      >
        <Icon size={19} className="asb__link-icon" />
        <span className="asb__link-label">{group.label}</span>
        {open
          ? <ChevronDown size={15} className="asb__group-chevron" />
          : <ChevronRight size={15} className="asb__group-chevron" />
        }
      </button>

      {open && (
        <div className="asb__group-children">
          {group.children.map(item => (
            <SidebarLink key={item.id} item={item} onClick={onLinkClick} />
          ))}
        </div>
      )}
    </div>
  );
};

const AdminSidebar = ({ isOpen, toggleSidebar }) => {
  // token k liya ye 2 lines
  const location = useLocation();
  const {authToken, setAuthToken } = useContext(AppContext);


  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const handleLinkClick = () => {
    if (isOpen) toggleSidebar();
  };
  // token k liya 
useEffect(() => {
  const token = localStorage.getItem("authToken");

  console.log("--------------------------------");
  console.log("ADMIN PAGE CHANGED:");
  console.log("PATH:", location.pathname);
  console.log("TOKEN:", token);
  console.log("--------------------------------");

}, [location]);

useEffect(() => {
  console.log(localStorage.getItem("authToken"));
}, [location]);
  return (
    <>
      {/* ══ MOBILE TOPBAR ══ */}
      <div className="asb-mob-topbar">
        <button className="asb-mob-topbar__hamburger" onClick={toggleSidebar}>
          {isOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
        <div className="asb-mob-topbar__brand">
          <span className="asb-mob-topbar__dash">━━</span>
          <span className="asb-mob-topbar__name">Admin</span>
        </div>
      </div>

      {/* ══ OVERLAY ══ */}
      {isOpen && <div className="asb-overlay" onClick={toggleSidebar} />}

      {/* ══ SIDEBAR ══ */}
      <aside className={'asb' + (isOpen ? ' asb--open' : '')}>

        {/* Header */}
        <div className="asb__header">
          <span className="asb__header-dash">━━</span>
          <div>
            <div className="asb__brand">WorkHub</div>
            <div className="asb__sub">Admin Panel</div>
          </div>
        </div>

        {/* Nav */}
        <nav className="asb__nav">
          {MENU_GROUPS.map(group => {
            // flat items (no dropdown)
            if (group.items) {
              return (
                <div key={group.id} className="asb__flat-group">
                  {group.items.map(item => (
                    <SidebarLink key={item.id} item={item} onClick={handleLinkClick} />
                  ))}
                </div>
              );
            }
            // collapsible group
            return (
              <div key={group.id} className="asb__section">
                <SidebarGroup group={group} onLinkClick={handleLinkClick} />
              </div>
            );
          })}
        </nav>

        {/* Logout */}
        <div className="asb__footer">
          <button className="asb__logout" onClick={handleLogout}>
            <LogOut size={18} />
            <span>Logout</span>
          </button>
        </div>

      </aside>
    </>
  );
};

export default AdminSidebar;